import React from "react";
import { Helmet } from "react-helmet";
import trans from "../../utils";
import BreadCrumb from "../Header/SecondHeader";
import OfflineConfig from "./OfflineConfig/OfflineConfig";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OfflineHeader from "../OfflineModules/OfflineHeader/OfflineHeader";
import ModeToggle from "./ModeToggle";

export default function OfflineSetup() {
	const navigate = useNavigate();
	const offlineMode = useSelector((state) => state.users.offlineMode);

	return (
		<div>
			<Helmet>
				<title>Offline-Setup</title>
				<meta name="description" content="Offline Setup" />
			</Helmet>
			{!offlineMode ? (
				<BreadCrumb
					title={trans("Offline Setup")}
					add={trans("Set-Up")}
					onClick={() => navigate("/setup/offline-setup-control")}
					type={"offline-setup"}
				/>
			) : (
				<OfflineHeader
					title={trans("Offline Setup")}
					subTitle={trans(
						"Configure modules for field use. Setup is required before activating Offline Mode",
					)}
					btn={<ModeToggle />}
					online={false}
				/>
			)}
			<OfflineConfig />
		</div>
	);
}
